module.exports = {"id":"228336","name":"Florian Grillitsch","rating":"74","photo":"./data/images/photos/1/228336.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["MC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlorianGrillitsch0.json
// module id = 1447
// module chunks = 0